import React, { useRef, useEffect } from 'react';
import CancelButton from '../linkButton'
import Button from '../button'
import dompurify from 'dompurify';
import parse from 'html-react-parser'
import PropTypes from 'prop-types';

import './style.scss';

const ConfirmDialog = (props) => {
  const dialogRef = useRef(0);
  const { showModal, title, message, confirmLabel, showCancelButton} = props;
  useEffect(() => {
    if (dialogRef.current?.open && !showModal) {
      dialogRef.current?.close()
    } else if (!dialogRef.current?.open && showModal) {
      dialogRef.current?.showModal()
    }
  }, [showModal])

  const handleDismiss = () => {
    if (dialogRef.current?.open) {
      dialogRef.current?.close()
    }
    if (props.onDismiss) {
      props.onDismiss();
    }
  }

  const handleConfirm = () => {
    if (dialogRef.current?.open) {
      dialogRef.current?.close()
    }
    if (props.onConfirm) {
      props.onConfirm();
    }
  }

  return (
    <dialog ref={dialogRef} className='confirm-dialog'>
      <div className='confirm-header'>
        <h1>{title}</h1>
        <button
          className='dismiss-button'
          onClick={handleDismiss}
          aria-label="Close"
        >
          X
        </button>
      </div>
      <div>
        <p>{parse(dompurify.sanitize(message))}</p>
      </div>
      <div className='confirm-buttons'>
        <Button label={confirmLabel ? confirmLabel : 'Confirm'} toUpperCase={false} action={handleConfirm}></Button>
        {(showCancelButton) && <CancelButton label='Cancel' clickAction={handleDismiss}/>}
      </div>
    </dialog>
  )
}

ConfirmDialog.propTypes = {
  showModal: PropTypes.bool,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  showCancelButton: PropTypes.bool,
  onDismiss: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ConfirmDialog;
